import { Box, IconButton, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import PlacesAutocomplete, { PlaceResult } from '../../components/common/PlacesAutocomplete';

interface StopListInputProps {
  stops: (PlaceResult | null)[];
  onChange: (stops: (PlaceResult | null)[]) => void;
}

export default function StopListInput({ stops, onChange }: StopListInputProps) {
  const handleStopChange = (index: number, place: PlaceResult | null) => {
    const newStops = [...stops];
    newStops[index] = place;
    onChange(newStops);
  };

  const handleAddStop = () => {
    onChange([...stops, null]);
  };

  const handleRemoveStop = (index: number) => {
    if (stops.length <= 2) return;
    const newStops = stops.filter((_, i) => i !== index);
    onChange(newStops);
  };

  return (
    <Box>
      {stops.map((stop, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1.5 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: stop ? 'primary.main' : 'grey.300',
              color: stop ? 'white' : 'text.secondary',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.8rem',
              fontWeight: 600,
              mt: 2.5,
              flexShrink: 0,
            }}
          >
            {index + 1}
          </Box>
          <Box sx={{ flex: 1 }}>
            <PlacesAutocomplete
              label={index === 0 ? 'Fra' : index === stops.length - 1 ? 'Til' : `Stop ${index}`}
              placeholder="Søg efter adresse..."
              value={stop}
              onChange={(place) => handleStopChange(index, place)}
            />
          </Box>
          {stops.length > 2 && (
            <IconButton
              size="small"
              onClick={() => handleRemoveStop(index)}
              sx={{ mt: 2.5 }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      ))}

      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={handleAddStop}
        sx={{ ml: 4.5 }}
      >
        Tilføj stop
      </Button>

      {stops.filter(Boolean).length >= 2 && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, ml: 4.5 }}>
          {stops.filter(Boolean).length} af {stops.length} stoppesteder udfyldt
        </Typography>
      )}
    </Box>
  );
}
